import React from 'react'
import { SkillCategoryContainer } from './SkillCategoryContainer'
import { UserSkillFormProps } from './types'

export const StyledUserSkillForm: React.FC<UserSkillFormProps> = props => {
  const categories = [
    { id: 1, name: 'エンジニアリング' },
    { id: 2, name: 'デザイン' },
    { id: 3, name: 'クリエイティブ' },
    { id: 4, name: 'ビジネス・マーケティング' },
    { id: 5, name: 'その他' }
  ]

  return (
    <>
      {categories.map(category => (
        <SkillCategoryContainer
          key={category.id}
          categoryName={category.name}
          categoryId={category.id}
          skillOption={props.skillOptions[category.id]}
        />
      ))}
    </>
  )
}
